import React__default from 'react';

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
var ChatIcon = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React__default.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "20",
    viewBox: "0 0 20 20"
  }, props), React__default.createElement("g", {
    fillRule: "evenodd",
    transform: "translate(0 -1)"
  }, React__default.createElement("path", {
    fillRule: "nonzero",
    d: "M16.492 16.539a1 1 0 0 1 .087-.99A7.94 7.94 0 0 0 18 11.002a8 8 0 1 0-3.716 6.743 1 1 0 0 1 .769-.128l2.176.521-.737-1.6zm2.047-.336l1.37 2.968a1 1 0 0 1-1.142 1.392l-3.781-.905A10 10 0 1 1 20 11a9.94 9.94 0 0 1-1.46 5.203z"
  }), React__default.createElement("rect", {
    width: "8",
    height: "2",
    x: "6",
    y: "8",
    rx: "1"
  }), React__default.createElement("rect", {
    width: "6",
    height: "2",
    x: "6",
    y: "12",
    rx: "1"
  })));
});

export default ChatIcon;
//# sourceMappingURL=chat.svg.js.map
